(function () {
    // Scroll reveal
    var reveals = document.querySelectorAll('.ff-reveal');
    var observer = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('ff-reveal--visible');
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    reveals.forEach(function (el) { observer.observe(el); });

    // Header scroll state
    var header = document.querySelector('.ff-site-header');
    if (header) {
        window.addEventListener('scroll', function () {
            if (window.scrollY > 80) {
                header.classList.add('ff-site-header--scrolled');
            } else {
                header.classList.remove('ff-site-header--scrolled');
            }
        }, { passive: true });
    }

    // Hero parallax
    var heroImg = document.querySelector('.ff-hero__img');
    if (heroImg && window.innerWidth > 768) {
        window.addEventListener('scroll', function () {
            var scroll = window.scrollY;
            if (scroll < window.innerHeight) {
                var offset = scroll * 0.3;
                heroImg.style.transform = 'scale(' + (1 + scroll * 0.0001) + ') translateY(' + offset + 'px)';
            }
        }, { passive: true });
    }

    // Fullscreen menu overlay
    var menuBtn = document.querySelector('.ff-nav__menu-btn');
    var menuOverlay = document.querySelector('.ff-menu-overlay');
    var menuClose = document.querySelector('.ff-menu-overlay__close');

    if (menuBtn && menuOverlay) {
        menuBtn.addEventListener('click', function () {
            menuOverlay.classList.add('ff-menu-overlay--open');
            menuOverlay.setAttribute('aria-hidden', 'false');
            document.body.classList.add('ff-menu-open');
        });

        if (menuClose) {
            menuClose.addEventListener('click', function () {
                menuOverlay.classList.remove('ff-menu-overlay--open');
                menuOverlay.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('ff-menu-open');
            });
        }

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && menuOverlay.classList.contains('ff-menu-overlay--open')) {
                menuOverlay.classList.remove('ff-menu-overlay--open');
                menuOverlay.setAttribute('aria-hidden', 'true');
                document.body.classList.remove('ff-menu-open');
            }
        });
    }

    // Scroll indicator
    var scrollIndicator = document.querySelector('.ff-scroll-indicator');
    if (scrollIndicator && window.innerWidth > 768) {
        var darkSections = document.querySelectorAll('.ff-hero, .ff-heritage-strip, .ff-editorial, .ff-lookbook--statement');
        window.addEventListener('scroll', function () {
            var midY = window.innerHeight / 2;
            var docHeight = document.documentElement.scrollHeight;
            var scrollBottom = window.scrollY + window.innerHeight;

            if (scrollBottom > docHeight - 300) {
                scrollIndicator.classList.add('ff-scroll-indicator--hidden');
            } else {
                scrollIndicator.classList.remove('ff-scroll-indicator--hidden');
            }

            var overDark = false;
            darkSections.forEach(function (section) {
                var rect = section.getBoundingClientRect();
                if (rect.top < midY && rect.bottom > midY) {
                    overDark = true;
                }
            });

            if (overDark) {
                scrollIndicator.classList.remove('ff-scroll-indicator--dark');
            } else {
                scrollIndicator.classList.add('ff-scroll-indicator--dark');
            }
        }, { passive: true });
    }
})();
